/** @jsxImportSource @emotion/react */

import { Modal, Select } from "antd";
import { CommonIcons } from "assets/common/icons";
import { LIST_ICON_VIP } from "constants/list-vip";
import { ModalTypeValue } from "enums/modalType";
import { currency } from "helpers/formatCurrency";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useState } from "react";
import { selectOpenModal, setOpenModal } from "store/master";
import { selectDataMemberVip } from "store/memberVip";
import { TypeBroadVip } from "types/memberVip";

import { ModalMemberVipMobileStyle } from "./style.index";

const ModalMemberVipMobile = () => {
  const openModal = useAppSelector(selectOpenModal);
  const dispatch = useAppDispatch();

  const [selectId, setSelectId] = useState<string>("");

  const { data: dataMemberVip } = useAppSelector(selectDataMemberVip);

  const dataVip = dataMemberVip?.board?.map((itemMap: TypeBroadVip) => {
    return {
      ...itemMap,
      icon: LIST_ICON_VIP,
    };
  });

  const handleChange = (value: string) => {
    setSelectId(String(Number(value) - 1));
  };

  return (
    <Modal
      className="modal__member-vip-mobile"
      open={openModal === ModalTypeValue.MOBILE_VIP}
      onCancel={() => {
        dispatch(setOpenModal(ModalTypeValue.CLOSE));
      }}
      css={ModalMemberVipMobileStyle.modalWrap}
      footer={<></>}
      centered
    >
      <div css={ModalMemberVipMobileStyle.wrapper}>
        <div css={ModalMemberVipMobileStyle.header}>
          <img src={LIST_ICON_VIP?.[Number(selectId)]} alt="" />
          <Select
            className="select-member-vip"
            suffixIcon={<CommonIcons.ArrowVipIcon />}
            onChange={handleChange}
            defaultValue={dataVip?.[0]?.id}
          >
            {dataMemberVip?.board?.map((item: TypeBroadVip, index: number) => (
              <Select.Option key={index} value={item.id}>
                VIP {item.id}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div css={ModalMemberVipMobileStyle.mainContent}>
          <table>
            <tbody>
              <tr>
                <th>Tích luỹ cược hợp lệ</th>
                <td>
                  {currency(Number(dataVip?.[Number(selectId)]?.max_turnover))}
                </td>
              </tr>
              <tr>
                <th>Tích luỹ tiền nạp</th>
                <td>
                  {currency(Number(dataVip?.[Number(selectId)]?.max_deposit))}
                </td>
              </tr>
              <tr>
                <th>Tiền thưởng nâng cấp</th>
                <td>
                  {currency(
                    Number(dataVip?.[Number(selectId)]?.level_up_bonus),
                  )}
                </td>
              </tr>
              <tr>
                <th>Thưởng tháng</th>
                <td>
                  {currency(Number(dataVip?.[Number(selectId)]?.montly_bonus))}
                </td>
              </tr>
              <tr>
                <th>Quà sinh nhật</th>
                <td>
                  {currency(
                    Number(dataVip?.[Number(selectId)]?.birthday_bonus),
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  );
};

export default ModalMemberVipMobile;
